export type ThdfQrDetails = {
  thdfId?: string | null;
  travellerId?: string | null;
  screeningId?: string | null;
  outcomeId?: string | null;
  travellerName?: string | null;
  passportNumber?: string | null;
  nationality?: string | null;
  arrivalDate?: string | null;
};

const sanitize = (value?: string | null): string | undefined => {
  if (value === undefined || value === null) return undefined;
  const trimmed = String(value).trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const THDF_QR_VERSION = 1;
export const THDF_QR_PREFIX = `ULENDO:THDF:${THDF_QR_VERSION}:`;

export const buildThdfQrValue = (details: ThdfQrDetails): string | null => {
  const thdfId = sanitize(details.thdfId);
  if (!thdfId) {
    return null;
  }
  // The server assigns a random UUID. Never encode traveller or health details.
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(thdfId)) return null;
  return `${THDF_QR_PREFIX}${thdfId}`;
};
